import { FC, PropsWithChildren } from 'react';

import { Box, BoxProps } from '@mui/material';
import { SxStyles } from 'types';
import { mergeSx } from 'utils';

interface ILinkButtonProps {
  link: string;
  sx?: SxStyles;
  onClick?: BoxProps<'a'>['onClick'];
}

const LinkContainer: FC<PropsWithChildren<ILinkButtonProps>> = ({ link, sx, onClick, children }) => {
  return (
    <Box
      component="a"
      href={link ?? ''}
      rel="noreferrer"
      target="_blank"
      sx={mergeSx({ display: 'inline-block', textDecoration: 'none' }, sx)}
      tabIndex={-1}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};

export default LinkContainer;
